import React, { useEffect, useState } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';

import { WalletProvider, useWallet } from './context/WalletContext';
import { ContractProvider } from './context/ContractContext';
import { NotificationProvider } from './context/NotificationContext';

import AppShell from './components/layout/AppShell';
import SplashLoader from './components/loader/SplashLoader';
import ToastContainer from './components/notifications/ToastContainer';
import NetworkGuard from './components/wallet/NetworkGuard';

import Dashboard from './pages/Dashboard';
import Invest from './pages/Invest';
import MyNFTs from './pages/MyNFTs';
import Team from './pages/Team';
import Activity from './pages/Activity';
import Admin from './pages/Admin';
import ConnectPrompt from './pages/ConnectPrompt';

import { APP } from './config/appConfig';

function Routed() {
  const { account } = useWallet();
  if (!account) {
    return (
      <AppShell>
        <ConnectPrompt />
      </AppShell>
    );
  }
  return (
    <NetworkGuard>
      <AppShell>
        <Routes>
          <Route path="/"          element={<Dashboard />} />
          <Route path="/invest"    element={<Invest />} />
          <Route path="/nfts"      element={<MyNFTs />} />
          <Route path="/team"      element={<Team />} />
          <Route path="/activity"  element={<Activity />} />
          <Route path="/admin"     element={<Admin />} />
          <Route path="*"          element={<Navigate to="/" replace />} />
        </Routes>
      </AppShell>
    </NetworkGuard>
  );
}

export default function App() {
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setBooting(false), APP.splashMinMs);
    return () => clearTimeout(t);
  }, []);

  return (
    <NotificationProvider>
      <WalletProvider>
        <ContractProvider>
          <HashRouter>
            {booting ? <SplashLoader /> : <Routed />}
            <ToastContainer />
          </HashRouter>
        </ContractProvider>
      </WalletProvider>
    </NotificationProvider>
  );
}
